import {motion} from "framer-motion";
import React from "react";

const MySeriesCard = ({ children, className = '' }) => {
    return   <motion.div
        whileHover={{ y: -5, boxShadow: "0 10px 30px -15px rgba(0, 0, 0, 0.1)" }}
        transition={{ duration: 0.2 }}
        className={`bg-white rounded-lg shadow-sm p-6 ${className}`}
    >
        {children}
    </motion.div>
};

export default MySeriesCard;
